import { useMutation } from 'react-query'
import { QueryNames } from 'Hooks/api/queryNames'

import { checkPlaidTokenStatus } from 'Services/JOONAdmin/joonAdminUsersService'

export const useCheckPlaidTokenStatusQuery = (userId: number) => {
  return useMutation([QueryNames.CheckPlaidTokenStatus], (transactionAccountId: number) =>
    checkPlaidTokenStatus(userId, transactionAccountId)
  )
}
